import React from "react";
import "./Header.css";
import { List, InstagramLogo, TwitterLogo } from "@phosphor-icons/react";
import { Button } from "@mui/joy";
interface HeaderProps {
  onNaviToggle: () => void;
}

const Header: React.FC<HeaderProps> = ({ onNaviToggle }) => {
  const formUrl =
    "https://docs.google.com/forms/d/e/1FAIpQLSfJXUfEx7M6XLWaPXVuv7bj37qwq9uvFlvXbzHZrDZiI42qOw/viewform?usp=pp_url";

  const instagramUrl = "https://www.instagram.com/campuspocket_official";
  const twitterUrl = "https://twitter.com/campoke_info";
  const appStoreUrl ="https://apps.apple.com/jp/app/campuspocket/id6461417915";
  const googlePlayUrl =
    "https://play.google.com/store/apps/details?id=com.campus_pocket.campus_pocket";

  return (
    <header>
      <div className="inner">
        {/* <p className="logo">
            Campus Pocket
        </p> */}
        <div style={{ display: "flex", height: "50px" }}>
          <img
            src="/web/images/campus-pocket-logo.png"
            alt="CampusPocketロゴ"
            style={{ height: "100%" }}
          ></img>
        </div>
        <ul className="navi">
          {/* <li>
            <a href="/feature/">機能説明</a>
          </li>
          <li>
            <a href="/service/">デモ</a>
          </li> */}
          <Button
            className="button-outline-header"
            onClick={() => {
              window.open(appStoreUrl, "_blank");
            }}
          >
            <img
              src="/web/images/apple-logo.png"
              alt="apple-logo"
              style={{ height: "24px" }}
            />
          </Button>
          <Button
            className="button-outline-header"
            onClick={() => {
              window.open(googlePlayUrl, "_blank");
            }}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.406 1.33934C3.15 1.60234 3 2.01134 3 2.54134V21.4573C3 21.9873 3.149 22.3973 3.406 22.6603L3.47 22.7183L14.326 12.1223V11.8723L3.47 1.27734L3.406 1.33934Z"
                fill="black"
              ></path>
              <path
                opacity="0.2"
                d="M17.9412 15.6568L14.3262 12.1238V11.8738L17.9462 8.33984L18.0262 8.38584L22.3132 10.7658C23.5362 11.4428 23.5362 12.5548 22.3132 13.2348L18.0272 15.6108L17.9412 15.6568Z"
                fill="black"
              ></path>
              <path
                d="M18.0262 15.61L14.3262 11.998L3.40625 22.661C3.81225 23.078 4.47525 23.128 5.22825 22.711L18.0262 15.611V15.61Z"
                fill="black"
                fill-opacity="0.8"
              ></path>
              <path
                opacity="0.4"
                d="M18.0262 8.38621L5.22825 1.28621C4.47525 0.872216 3.81225 0.922216 3.40625 1.34021L14.3262 11.9992L18.0262 8.38621Z"
                fill="black"
              ></path>
            </svg>
          </Button>
          <Button
            className="button-outline-header"
            onClick={() => {
              window.open(instagramUrl, "_blank");
            }}
          >
            <InstagramLogo size={28} color="#292929" />
          </Button>
          <Button
            className="button-outline-header"
            onClick={() => {
              window.open(twitterUrl, "_blank");
            }}
          >
            <TwitterLogo size={28} color="#292929" />
          </Button>
          <li>
            <Button
              className="button-fill-header"
              onClick={() => {
                window.open(formUrl, "_blank");
              }}
            >
              お問い合わせ
            </Button>
          </li>
        </ul>
      </div>
      <button
        className="sp-navi-toggle"
        style={{ lineHeight: "50px", verticalAlign: "middle" }}
        onClick={onNaviToggle}
      >
        <div
          style={{
            height: "100%",
            display: "flex",
            width: "50px",
            verticalAlign: "middle",
          }}
        >
          <List size={32} color="#333333" weight="bold" />
        </div>
      </button>
    </header>
  );
};

export default Header;
